import { ProcessedBreadcrumbs } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import {
  Box,
  ChevronRightIcon,
  constants,
  Text,
  TextLink,
} from '@redbubble/design-system';
import {
  InteractElementAction,
  trackGA4InteractElement,
} from '../../utils/analytics';
import styles from './Breadcrumbs.module.scss';

interface BreadcrumbsProps {
  breadcrumbs: ProcessedBreadcrumbs;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
  return (
    <Box className={styles.linkWrapper}>
      {breadcrumbs.map((crumb, index) => {
        return (
          <Box display="inline" key={crumb.name.split(' ').join('_')}>
            {crumb.url ? (
              <TextLink
                href={crumb.url}
                onClick={() =>
                  trackGA4InteractElement({
                    item: {
                      name: 'breadcrumb',
                      text: crumb.name,
                      url: crumb.url,
                    },
                    context: {
                      position: 'bottom left',
                      parent: breadcrumbs[index - 1]?.name,
                    },
                    action: InteractElementAction.Click,
                    isOutbound: false,
                    isNav: false,
                  })
                }
              >
                {crumb.name}
              </TextLink>
            ) : (
              <Text className={styles.crumb} type="display5">
                {crumb.name}
              </Text>
            )}
            {breadcrumbs.length - 1 !== index && (
              <ChevronRightIcon
                color={constants.COLOR_NEUTRAL_500}
                size={constants.SMALL}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};
